import React, { useContext, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { animated, useSpring } from 'react-spring';
import StatBlock from 'components/statBlock/statBlock';
import IconCar from 'icons/iconCar';
import { getMillionsShort } from 'helpers/utils';
import IconDTP from 'icons/iconDTP';
import IconCone from 'icons/iconCone';
import { UiContext } from 'uiContext';
import WeatherForecast from 'components/weatherForecast/weatherForecast';
import { WeatherType } from 'mobx/commonTypes';

export default function DropdownMenuInnerDesktop({
  isOpen,
  transport_count,
  large_accidents,
  roadwork_detail,
  weather,
}: {
  isOpen: boolean;
  transport_count: number;
  large_accidents: number;
  roadwork_detail: number;
  weather: WeatherType;
}) {
  const theme = useTheme();
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const [maxHeight, setMaxHeight] = useState(0);

  const AnimeBox = animated(Box);
  const anime = useSpring({
    maxHeight: isOpen ? maxHeight : 0,
    marginBottom: isOpen ? parseFloat(theme.spacing(sp.s30)) : 0,
    marginTop: isOpen ? parseFloat(theme.spacing(sp.s10)) : 0,
  });

  return (
    <AnimeBox
      style={anime}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 1,
        overflow: 'hidden',
        height: 'auto',
      }}
    >
      <Box
        ref={(el: HTMLDivElement | null) => {
          if (el) {
            setMaxHeight(el.offsetHeight);
          }
        }}
        sx={{
          'display': 'flex',
          'justifyContent': 'space-between',
          'width': 1,
          'gap': sp.s25,
          '& > *': {
            flexBasis: 1,
            flexGrow: 1,
          },
        }}
      >
        <StatBlock
          text="Кол-во уникальных автомобилей"
          icon={<IconCar></IconCar>}
          value={getMillionsShort(transport_count)}
          timeText="сегодня"
        ></StatBlock>
        <StatBlock
          text="Крупные ДТП"
          icon={<IconDTP></IconDTP>}
          value={String(large_accidents)}
          timeText="сейчас"
        ></StatBlock>
        <StatBlock
          text="Дорожные работы"
          icon={<IconCone></IconCone>}
          value={String(roadwork_detail)}
          timeText="сегодня"
        ></StatBlock>
        <WeatherForecast weather={weather} />
      </Box>
    </AnimeBox>
  );
}
